export default __webpack_public_path__ + "static/catalog-2e40cf5d260a2b1408ffd72b92a4ee96.pdf";